module.exports = __webpack_public_path__ + "img/Delivery_hand_nope.a9980536.png";